module.exports = __webpack_public_path__ + "img/waifu1.c0795a5c.png";